var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MidmarkTypography from '../Typography/MidmarkTypography';
const linkSmallStyles = {
    fontWeight: 'bold',
    fontSize: '0.75rem',
    letterSpacing: '1.2px',
    opacity: 1,
    '&:hover': {
        cursor: 'pointer',
    },
};
const linkLargeStyles = {
    fontWeight: 'bold',
    fontSize: '0.875rem',
    letterSpacing: '1.2px',
    opacity: 1,
    '&:hover': {
        cursor: 'pointer',
    },
};
const buttonStyles = {
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    borderRadius: 0,
    padding: 0,
    cursor: 'pointer',
    width: 'fit-content',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    WebkitAppearance: 'none',
    '&::-moz-focus-inner': {
        borderStyle: 'none', // Remove Firefox dotted outline.
    },
    '&$focusVisible': {
        outline: 'auto',
    },
};
const underlineStyles = {
    textDecoration: 'underline',
};
const StyledMidmarkTypography = styled(MidmarkTypography, {
    shouldForwardProp: (prop) => ['size', 'underline', 'disabled'].some((ignoreProp) => ignoreProp !== prop),
})(({ size, underline, color, variant, component, theme, disabled }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (color === undefined &&
    variant != 'overline' &&
    variant != 'overlineActive' && { color: theme.palette.text.link })), (size === 'large' ? linkLargeStyles : linkSmallStyles)), (component === 'button' && buttonStyles)), (underline === 'always' && underlineStyles)), (underline === 'hover' && { '&:hover': underlineStyles })), (disabled && {
    color: theme.palette.text.hint,
    pointerEvents: 'none',
}))));
function MidmarkLink(_a) {
    var { size = 'small', underline = 'always', variant = 'body1', component = 'a', color, children } = _a, newProps = __rest(_a, ["size", "underline", "variant", "component", "color", "children"]);
    return (_jsx(StyledMidmarkTypography, Object.assign({ underline: underline, size: size, variant: variant, component: component, color: color }, newProps, { children: children })));
}
export default MidmarkLink;
